/**
 * Frosted-glass surfaces for the island, matching Apple's AirPods-Max controls:
 * a LIGHT pill for the gallery pagination (light type over imagery) and a DARK
 * pill for links / CTAs. Both: heavy blur, soft drop shadow, hairline edge.
 * `pointer-events-auto` re-enables clicks inside the click-through island band.
 */
/*
The island floats outside the page's own subtree, so each pill declares the
ground its focus rings sit on rather than inheriting the page's.
*/
export const ISLAND_GLASS_LIGHT =
    'pointer-events-auto bg-white/60 text-gray-900 shadow-[0_8px_30px_rgba(0,0,0,0.18)] ring-1 ring-white/50 backdrop-blur-2xl focus-ring-on-light';

export const ISLAND_GLASS_DARK =
    'pointer-events-auto bg-black/55 text-white shadow-[0_8px_30px_rgba(0,0,0,0.3)] ring-1 ring-white/10 backdrop-blur-2xl focus-ring-on-dark';

/**
 * Shared framer-motion layoutId for the dark glass pill. Surfaces that share
 * the island's `pill` surface key (CTA/link pill, bulk enquiry pill) tag their
 * glass with this so a mode switch morphs one continuous pill — position and
 * width animate, contents cross-fade — instead of popping out and back in.
 */
export const ISLAND_GLASS_LAYOUT_ID = 'magic-island-glass';
